import { createFileRoute } from '@tanstack/react-router';
import TenantProfileView from '@features/tenant-profile/TenantProfileView';

export const Route = createFileRoute('/w/dashboard/profile/$tenantId')({
  staticData: { breadcrumb: 'Client Profile', breadcrumbKey: 'K_BREADCRUMB_TENANT_PROFILE' },
  validateSearch: (search: Record<string, unknown>): { edit?: boolean } => {
    if (search.edit === true || search.edit === 'true') return { edit: true };
    return {};
  },
  component: AdminTenantProfilePage,
});

function AdminTenantProfilePage() {
  const { tenantId } = Route.useParams();
  const { edit } = Route.useSearch();

  return (
    <TenantProfileView
      mode={{ kind: 'admin', tenantId }}
      initialEdit={edit ?? false}
    />
  );
}
